import { CircleUserRound } from "lucide-react";
import {
  KeyValueViewType,
  type KeyValueItem,
} from "@repo/types/ui/keyValuePairs";
import BlobImage from "../image/BlobImage";
import TruncatedText from "../TruncatedText";

export default function KeyValueMenuItem({
  item,
  imageClassName,
  variant,
}: {
  item: KeyValueItem;
  imageClassName?: string;
  variant?: "default" | "chip";
}) {
  const imgClass =
    imageClassName ||
    (variant === "chip"
      ? "w-4 h-4 rounded-full object-cover"
      : "w-5 h-5 rounded-full object-cover");

  switch (item.viewType) {
    case KeyValueViewType.iconOnly:
      return item.icon || item.fallbackIcon;

    case KeyValueViewType.textOnly:
      return <TruncatedText text={item.Value} maxLength={15} />;

    case KeyValueViewType.iconAndText:
      return (
        <div className="flex items-center gap-x-2">
          <div
            className={`flex items-center justify-center ${
              variant === "chip" ? "w-4 h-4" : "w-5 h-5"
            }`}
          >
            {/* FIX: icon always first */}
            {item.icon || item.fallbackIcon || (
              <CircleUserRound className="w-4 h-4 text-gray-500" />
            )}
          </div>
          <TruncatedText text={item.Value} maxLength={15} />
        </div>
      );

    case KeyValueViewType.imageOnly:
      if (variant === "chip") {
        return item.icon || item.fallbackIcon;
      }
      return (
        <BlobImage
          src={item.image}
          className={imgClass}
          fallback={item.fallbackImage}
        />
      );

    case KeyValueViewType.imageAndText:
      if (variant === "chip") {
        return (
          <div className="flex items-center gap-x-2">
            <div className="w-6 h-6 flex items-center justify-center">
              {item.icon || item.fallbackIcon || (
                <CircleUserRound className="w-8 h-8 text-gray-500 opacity-30" />
              )}
            </div>
            <TruncatedText text={item.Value} maxLength={15} />
          </div>
        );
      }
      console.log("ICON DEBUG =>", {
        icon: item.icon,
        fallbackIcon: item.fallbackIcon,
        viewType: item.viewType,
      });
      return (
        <div className="flex items-center gap-x-2">
          <BlobImage
            src={item.image}
            className={imgClass}
            fallback={item.fallbackImage}
          />
          <TruncatedText text={item.Value} maxLength={15} />
        </div>
      );

    default:
      return null;
  }
}
